import { FirebaseAnalytics as CapacitorFirebaseAnalytics } from '@capacitor-community/firebase-analytics';
import { isNativeNotWeb } from './platform-check';

/**
 * Wrapper for Firebase Analytics that only executes on native platforms
 * This prevents errors when Firebase Analytics is called on web
 *
 * Usage: import { FirebaseAnalytics } from "@/utils/firebase-analytics-wrapper";
 * (Same import name, just change the path)
 */

// Check if we're on native platform
const isNative = isNativeNotWeb();

// Export as FirebaseAnalytics so imports don't need to change
export const FirebaseAnalytics = {
  setUserId: async options => {
    if (isNative) {
      return await CapacitorFirebaseAnalytics.setUserId(options);
    }
  },

  setUserProperty: async options => {
    if (isNative) {
      return await CapacitorFirebaseAnalytics.setUserProperty(options);
    }
  },

  logEvent: async options => {
    if (isNative) {
      return await CapacitorFirebaseAnalytics.logEvent(options);
    }
    console.log('[Firebase] logEvent (web no-op):', options?.name, options?.params);
  },

  setScreenName: async options => {
    if (isNative) {
      return await CapacitorFirebaseAnalytics.setScreenName(options);
    }
  },

  setCollectionEnabled: async options => {
    if (isNative) {
      return await CapacitorFirebaseAnalytics.setCollectionEnabled(options);
    }
  },

  initializeFirebase: async options => {
    if (isNative) {
      return await CapacitorFirebaseAnalytics.initializeFirebase(options);
    }
  },
};
